import { useSelector } from 'react-redux';

import { selectBuildingCard } from 'shared/selectors/buildingCard';
import { selectSimilarBuildings } from 'shared/selectors/similarBuildings';
import { getSimilarBuildingsTitle, getSimilarBuildingView } from 'shared/utils/similarBuildings';

import { SimilarBuildings } from './SimilarBuildings';

/** Без похожих блок не рендерится */
export const SimilarBuildingsContainer = () => {
  const { type } = useSelector(selectBuildingCard);
  const buildings = useSelector(selectSimilarBuildings);

  return buildings.length ? (
    <SimilarBuildings title={getSimilarBuildingsTitle(type)} buildings={buildings.map(getSimilarBuildingView)} />
  ) : null;
};
